import React from 'react'

const Sheltered = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M2.10156 12.502L12.7031 4.42188L17.7439 8.46191M17.7439 8.46191L22.7847 12.502M17.7439 8.46191V4.42188M9.33008 14.3555H15.5566V20.582H9.33008V14.3555Z"
      stroke={color}
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default Sheltered
